<template>
  <section>
    <div class="page">
      <div>
        <h2>Managing group admins</h2>
        <p>
          Any admin in the group can make a participant an admin. A group can
          have an unlimited number of admins.
        </p>
        <p>
          Note: The original creator of a group can't be removed and will always
          remain an admin unless they exit the group.
        </p>
        <h3>To make a participant an admin</h3>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Tap <strong>Group Management > Admin List > + </strong>button > Tap
            the participant you want to make an admin.
          </li>
          <li>Tap <strong>Confirm > ok</strong>.</li>
        </ol>
        <h3>To dismiss an admin</h3>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Tap <strong>Group Management</strong> > <strong>Admin List</strong>.
          </li>
          <li>
            Tap and hold the admin. Then tap <strong>Disqualify Admin</strong>.
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
